<template>
  <div class="row m-0">
    <notify-popup :trustor="trustorNotify" :user="currentUser" v-if="isNotify" @close="close" @cancel="cancel"></notify-popup>
    <div class="col-12 mb-3 px-0 pb-3 border-bottom">
      <div class="row m-0 align-items-center">
        <div class="col p-0">
          <h4 class="mb-0">Trustors</h4>
        </div>
      </div>
    </div>
    <div class="col-12 p-3 p-md-4">
      <div class="row mx-0 justify-content-center">
        <div class="col-11 col-md-8 col-lg-7 col-xl-6 p-0">
          Click Notify below if something has happened to the loved one you are a trustee for. Your loved one’s information will be released after security confirmation as per your loved one’s wishes.
        </div>
      </div>
    </div>
    <div class="col-12 p-3 p-md-4 white_bg">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="row m-0 py-2 mb-2 border-bottom align-items-center" v-for="(trustor, key) in trustors" :key="trustor.email">
            <div class="col-6 p-0">
              <div class="row m-0">
                <div class="col-12 p-0 bold">
                  {{trustor.firstname}} {{trustor.lastname}}
                </div>
                <div class="col-12 p-0 smallfont">
                  {{trustor.email}}
                </div>
              </div>
            </div>
            <div class="col-6 p-0 text-end" v-if="trustor.notified">
              Notified
            </div>
            <div class="col-6 p-0 text-end" v-else-if="trustor.confirmed">
              <button class="btn btn-primary" @click="notify(key)" >
                Notify
              </button>
            </div>
            <div class="col-6 p-0 text-end" v-else>
              <button class="btn btn-green me-3" @click="confirmTrustor(key)">
                Confirm
              </button>
              <button class="btn btn-secondary" @click="denyTrustor(key)" v-if="!trustor.confirmed">
                Decline
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Trustors',
  components: {
    'notify-popup': () => import('../components/NotifyTrustorPopup.vue')
  },
  data () {
    return {
      isNotify: false,
      trustorNotify: {},
      trustorKey: '',
      notifing: false
    }
  },
  watch: {
    trustors () {
      if (Object.keys(this.trustors).length === 0) {
        this.$router.push('/')
      }
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'currentUser', 'trustors'])
  },
  methods: {
    ...mapActions(['notifyTrustor', 'confirmTrustor', 'denyTrustor']),
    notify (key) {
      this.isNotify = true
      this.trustorKey = key
      this.trustorNotify = this.trustors[key]
    },
    close () {
      this.isNotify = false
      this.notifyTrustor(this.trustorKey)
      this.trustorKey = ''
      this.trustorNotify = {}
    },
    cancel () {
      this.isNotify = false
      this.trustorKey = ''
      this.trustorNotify = {}
    }
  }
}
</script>

<style scoped>
</style>
